import { client } from '@repo/shared-kit/utils';
import { registerBaseURL } from '../../constants/hosts';

export async function postOrganizationRegisterV2(organizationId: string): Promise<void> {
  await client(`${registerBaseURL}/v2/organizations/${organizationId}/register`, {
    method: 'POST',
  });
}
